import axios from 'axios';

import { SERVICEBASEURL } from 'enums/serviceBaseUrls';
import { Optional } from 'functions/promiseExtensions';

export function callApi(postObject: Request): Promise<Optional<string>> {
	const url = `${SERVICEBASEURL.BACKEND}/Language`;
	return axios.post(url, postObject).toOptionalMapped((x) => x.data);
}

export interface Request {
	cultureCode: string;
	sortOrder: number;
	isoCode6391: string;
	isoCode6393: string;
	hasArticleBeforeIngredientName: boolean;
	translationCode: string | null;
	nameTranslations: {
		[key: string]: string;
	};
}

export interface Response {
	data: string;
}
